import React, { useState } from 'react';
import notification from '../../../assets/images/dashboard/header/bell.svg';
import arrow from '../../../assets/images/dashboard/header/doenArrow.svg';
import search from "../../../assets/images/dashboard/body/Search.svg";
import img from "../../../assets/images/img.svg";
import card from "../../../assets/images/dashboard/couponCard.svg";
import cardPopUp from "../../../assets/images/dashboard/cardPopUp.svg"

const VolunteerCoupons = () => {
  const [datePickerModal, setDatePickerModal] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [flipped, setFlipped] = useState(Array(12).fill(false));


  const toggleDatePickerModal = () => setDatePickerModal(!datePickerModal);

  const handleBoxClick = (image) => {
    setIsPopupOpen(true);
  };

  const handleFlip = (index) => {
    console.log("index", index);
    const newFlipped = [...flipped];
    newFlipped[index] = !newFlipped[index];
    setFlipped(newFlipped);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <div>
      <div className='hidden lg:flex py-4 lg:pr-10 bg_header border-b-2 border-[#362269]'>
        <div className='relative hidden lg:flex items-center pl-8'>
          <input
            type="search"
            placeholder='Search'
            className='min-w-[625px] h-8 border-0 rounded-lg'
          />
          <img src={search} alt="search" className='absolute right-[15px] top-[10px]' />
        </div>

        <div className='hidden md:flex ml-auto items-center'>
          <span className='w-8 h-8 rounded-full'>
            <img src={img} alt="img" />
          </span>

          <div className='flex items-center'>
            <p className='pl-3 font-bold'>Volunteer</p>
          </div>

          <img src={notification} alt="notification" className='pl-4 text-black' />
        </div>
      </div>

      <div className='xl:w-[85%] mx-auto mt-16 hidden lg:flex items-center justify-between'>
        <b className='font_family'>Coupons</b>

        <div className='flex'>
          <button
            onClick={toggleDatePickerModal}
            className="w-[112px] h-[40px] border flex justify-center items-center border-gray-300 ml-2 bg-[#D6FACD] text-[10px] py-1 px-2 rounded-xl"
          >
            Filter by date
            <img src={arrow} alt="arrow" className='w-[10px] h-auto p-[1px] ml-1' />
          </button>
        </div>
      </div>

      {/* Grid of Coupons */}
      <div className='relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 py-16'>
        <div className='circle_design'></div>

        {Array.from({ length: 12 }).map((_, index) => (
          <div
            key={index}
            className={`flip-card ${flipped[index] ? 'flipped' : ''}`}
            onMouseEnter={() => handleFlip(index)}
           
          >
            <div className='flip-card-inner rounded-xl'>
              <div className='flip-card-front p-5 rounded-xl border-2 w-fit mx-auto cursor-pointer border_dark bg-[#F6F2EF]'>
                <img src={card} alt="card" />
                <b className='font_family text-[10px]'>2 Tickets to see Wicked on Broadway</b>
                <p className='ml-auto text-[8px] w-fit pt-2'>Expires in 4 Days</p>
              </div>

              <div className='flip-card-back '>
                <img src={cardPopUp} alt="cardPopUp " />
              </div>
            </div>
          </div>
        ))}
      </div>


      {/* Popup Modal */}
      {isPopupOpen && (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center px-4'>
          <div className='relative bg-[#F6F2EF] p-6 py-10 rounded-lg max-w-lg w-full'>
            <button
              className='absolute right-1 top-1 text-black text-xl'
              onClick={closePopup}
            >
              &#10006;
            </button>

            <img
              src={cardPopUp}
              alt="cardPopUp"
              className='w-full h-auto rounded-md'
            />
          </div>
        </div>
      )}

    </div>
  );
};

export default VolunteerCoupons;
